export enum DefaultValues {
  maxFileSizeInMB = 10,
  maxTotalUploadInMB = 200,
}
